import React from 'react';
import { useFormik } from 'formik';
import './Form.css';

const Form = () => {
  const formik = useFormik({
    initialValues: {
      name: '',
      mainText: '',
      body: '',
    },
    onSubmit: values => {
      console.log(values);
    },
  });

  return (
    <div className="container">
      <form onSubmit={formik.handleSubmit} className="form">
        <div className="form-row">
          <label htmlFor="name" className="label">Name:</label>
          <input
            id="name"
            name="name"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.name}
            className="input"
          />
        </div>
        <div className="form-row">
          <label htmlFor="mainText" className="label">Main Text:</label>
          <textarea
            id="mainText"
            name="mainText"
            onChange={formik.handleChange}
            value={formik.values.mainText}
            className="textarea"
          />
        </div>
        <div className="form-row">
          <label htmlFor="body" className="label">Body:</label>
          <textarea
            id="body"
            name="body"
            onChange={formik.handleChange}
            value={formik.values.body}
            className="textarea"
          />
        </div>
        <button type="submit" className="submit-btn">Submit</button>
      </form>
    </div>
  );
};

export default Form;